import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosSecured } from "../../api/axiosClient";
import {
  GET_NOTIFICATIONS,
  MARK_NOTI_AS_READ,
} from "../notifications/api/notifications-api";

const useNotificationsApi = () => {
  const {
    data: notificationsData = [],
    refetch: fetchNotifications,
    isLoading: isNotificationsLoading,
  } = useQuery({
    queryKey: ["fetchNotifications"],
    queryFn: () =>
      axiosSecured.get(GET_NOTIFICATIONS).then((res) => res.data.data),
  });

  const { mutateAsync: markNotificationAsRead } = useMutation({
    mutationFn: (id) =>
      axiosSecured
        .patch(MARK_NOTI_AS_READ(id))
        .then((res) => res.status === 200),
  });

  return {
    getAllNotificationsApi: {
      get: fetchNotifications,
      isLoading: isNotificationsLoading,
      data: notificationsData,
    },
    markNotificationAsReadApi: {
      patch: markNotificationAsRead,
    },
  };
};

export default useNotificationsApi;
